export default "__VITE_ASSET__2fb701c9__"